const _instances = {}

export default class Settings {
  static define(key, defaults = {}) {
    if (_instances[key]) {
      throw new Error('Settings with key `' + key + '` already defined')
    }

    _instances[key] = new Settings(key, defaults)

    return _instances[key]
  }

  static get(key) {
    if (!_instances[key]) {
      throw new Error(
        'Settings with key `' +
          key +
          '` not defined. Use Settings.define() to define new instance'
      )
    }

    return _instances[key]
  }

  constructor(key, defaults = {}) {
    this._key = key
    this._storage = Object.assign(
      defaults,
      JSON.parse(
        window.localStorage.getItem('settings.' + this._uid() + '.' + key)
      ) || {}
    )
    this._handlers = []
  }

  read() {
    return { ...this._storage }
  }

  _uid() {
    return window.firebaseUid || ''
  }

  write(data) {
    this._storage = Object.assign(this._storage, data)
    window.localStorage.setItem(
      'settings.' + this._uid() + '.' + this._key,
      JSON.stringify(this._storage)
    )

    this._handlers.forEach((handler) => handler({ ...this._storage }))
  }

  onChange(handler) {
    this._handlers.push(handler)
  }

  removeOnChange(handler) {
    const pos = this._handlers.indexOf(handler)
    if (pos > -1) {
      this._handlers.splice(pos, 1)
    }
  }
}
